/**
 * Leadership — clean portrait grid.
 */
const leaders = [
    { name: 'Ranjith Menon', title: 'Founder & CEO, AGEON', img: '/images/Ranjith Menon.jpeg' },
    { name: 'Shijith EK', title: 'Co-Founder, AGEON', img: '/images/Shijith E K.jpeg' },
    { name: 'Hari Kiran', title: 'Co-Founder & COO, EBG Group', img: '/images/Hari Kiran.jpeg' },
    { name: 'Saumen Basak', title: 'Operations Head, EBG Group', img: '/images/saumen.png' },
    { name: 'Aryan Sharma', title: 'Sales Head, EBG Group', img: '/images/aryan.png' },
];

export default function LandingLeadership() {
    return (
        <section id="leadership" className="relative scroll-mt-24 bg-white border-t border-ink-100/80">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-28">
                <div className="text-center max-w-2xl mx-auto mb-14" data-aos="fade-up">
                    <span className="lp-chip mb-6">Leadership</span>
                    <h2 className="font-heading font-extrabold text-3xl sm:text-4xl text-ink-900 tracking-tight">
                        Our leadership team
                    </h2>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-6">
                    {leaders.map((leader, index) => (
                        <div
                            key={leader.name}
                            className="flex flex-col items-center text-center"
                            data-aos="fade-up"
                            data-aos-delay={String(index * 70)}
                        >
                            <div className="relative h-28 w-28 sm:h-32 sm:w-32 mb-4">
                                <div className="absolute inset-0 grid place-items-center rounded-full bg-brand-teal-50 ring-1 ring-brand-teal/15">
                                    <span className="font-heading text-2xl font-extrabold text-brand-teal-700">
                                        {leader.name.split(' ').map(n => n[0]).join('').slice(0, 2)}
                                    </span>
                                </div>
                                <img
                                    src={leader.img}
                                    alt={leader.name}
                                    className="relative h-full w-full rounded-full object-cover object-top ring-4 ring-white shadow-[0_8px_24px_-8px_rgba(15,17,21,0.15)]"
                                    loading="lazy"
                                    onError={e => { e.currentTarget.style.display = 'none'; }}
                                />
                            </div>
                            <h3 className="font-heading font-bold text-sm text-ink-900">{leader.name}</h3>
                            <p className="mt-1.5 text-[11px] sm:text-xs text-ink-500 leading-snug max-w-[11rem]">{leader.title}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
